import { NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ɵEmptyOutletComponent } from '@angular/router';
import {
  AdditionalIncomeHeaderFieldTypeComponent,
} from '@shared/components/formly/fields/additional-income-header/additional-income-header.component';
import { ButtonsFieldTypeComponent } from '@shared/components/formly/fields/buttons/buttons.component';
import { CurrencyMultiAddFieldTypeComponent } from '@shared/components/formly/fields/currency-multi-add/currency-multi-add.component';
import { CurrencyFieldTypeComponent } from '@shared/components/formly/fields/currency/currency.component';
import { DateFieldTypeComponent } from '@shared/components/formly/fields/date/date.component';
import { DisabledFieldTypeComponent } from '@shared/components/formly/fields/disabled/disabled.component';
import { InputFieldTypeComponent } from '@shared/components/formly/fields/input/input.component';
import { MultiSelectFieldTypeComponent } from '@shared/components/formly/fields/multiselect/multiselect.component';
import { NumberFieldTypeComponent } from '@shared/components/formly/fields/number/number.component';
import { PostcodeInputComponent } from '@shared/components/formly/fields/postcode-input/postcode-input.component';
import { RadioButtonFieldTypeComponent } from '@shared/components/formly/fields/radio-button/radio-button.component';
import { RadioListComponent } from '@shared/components/formly/fields/radio-list/radio-list.component';
import { RepeatingFieldTypeComponent } from '@shared/components/formly/fields/repeating/repeating.component';
import { SelectFieldTypeComponent } from '@shared/components/formly/fields/select/select.component';
import { TextAreaFieldTypeComponent } from '@shared/components/formly/fields/textarea/textarea.component';
import { HtmlWrapperComponent } from '@shared/components/formly/wrappers';
import { FormCardWrapperComponent } from '@shared/components/formly/wrappers/form-card-wrapper/form-card-wrapper.component';
import {
  HorizontalFieldWrapperComponent,
} from '@shared/components/formly/wrappers/horizontal-field-wrapper/horizontal-field-wrapper.component';
import { ModalOptions } from '@shared/models';
import { ModalStateService } from '@shared/services';

/**
 * The component displayed in the confirmation modal opened by the ModalService.
 */
@Component({
  selector: 'lib-modal-component',
  styleUrls: ['modal.component.scss'],
  templateUrl: 'modal.component.html',
  imports: [
    NgTemplateOutlet,
    ButtonsFieldTypeComponent,
    CurrencyFieldTypeComponent,
    DateFieldTypeComponent,
    DisabledFieldTypeComponent,
    InputFieldTypeComponent,
    NumberFieldTypeComponent,
    PostcodeInputComponent,
    RadioButtonFieldTypeComponent,
    RadioListComponent,
    RepeatingFieldTypeComponent,
    SelectFieldTypeComponent,
    MultiSelectFieldTypeComponent,
    TextAreaFieldTypeComponent,
    AdditionalIncomeHeaderFieldTypeComponent,
    CurrencyMultiAddFieldTypeComponent,
    FormCardWrapperComponent,
    HtmlWrapperComponent,
    HorizontalFieldWrapperComponent,
    ɵEmptyOutletComponent,
  ],
})
export class ModalComponent implements AfterViewInit {
  private readonly state = inject(ModalStateService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public options: ModalOptions | undefined;
  public isDisabled = false;

  public constructor() {
    const state = this.state;

    this.options = state.options;
  }

  public ngAfterViewInit() {
    setTimeout(() => {
      if (this.options?.disabledTillScroll) {
        this.isDisabled = true;
      }
    }, 200);
  }

  public onScroll(event: any) {
    const distanceFromBottom = 120;
    if (
      this.options?.disabledTillScroll &&
      this.isDisabled &&
      event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - distanceFromBottom
    ) {
      this.isDisabled = false;
      this.changeDetectorRef.detectChanges();
    }
  }

  public yes() {
    this.state.topmostModal?.close('confirmed');
    if (this.state.modalStack?.length > 0) {
      this.state.modal = this.state.topmostModal;
    }
  }

  public no() {
    this.state.topmostModal?.dismiss('not confirmed');
    if (this.state.modalStack?.length > 0) {
      this.state.modal = this.state.topmostModal;
    }
  }

  public cross() {
    this.state.topmostModal?.dismiss('Cross click');
    if (this.state.modalStack?.length > 0) {
      this.state.modal = this.state.topmostModal;
    }
  }

  public get titleAlignment() {
    switch (this.options?.titleAlign) {
      case 'left':
        return 'text-left';
      case 'center':
        return 'text-center ml-4';
      case 'right':
        return 'text-right';
      default:
        return 'text-left';
    }
  }

  public get titleFloatingContentIsHtmlString(): boolean {
    return typeof this.options?.titleFloatingContent === 'string';
  }
}
